<template>
  <div class="px-4 pdf-preview">
    <!-- Header Section -->
    <div class="c-card u-p-small u-mb-small mx-2 pb-2 pt-3 sticky-card">
      <div class="row position-relative px-3 align-items-center">
        <h4 class="mb-1">PDF Preview</h4>
        <div class="ml-auto">
          <a :href="url" download @click.prevent="downloadPDF" size="md" class="btn c-btn-outlined-info"> <i class="fa  fa-file-pdf-o mr-2"></i> Download </a>
          <a target="_blank" :href="url" @click.prevent="onOpenInWord" size="md" class="btn c-btn-outlined-info mx-3">
            <i class="fa fa-file-word-o u-mr-xsmall"></i>
            Open in MS-Word
          </a>
          <b-button @click="onPrint" size="md" class="ss-info-bg border-0">
            <i class="fa fa-print u-mr-xsmall"></i>
            Print
          </b-button>
        </div>
        <!-- <p class="mb-1 mr-2">
            <strong>{{ headerSubTitle }}</strong>
          </p> -->
      </div>
    </div>

    <div class="c-card u-p-small u-mb-small mx-2 pt-3 pdf-container h-100vh">
      <div v-if="loading" class="d-flex flex-column align-items-center justify-content-center h-100">
        <LoadingScreen />
        <p v-if="retryCount > 0" class="mt-3 text-muted">
          Loading PDF... (Attempt {{ retryCount }}/{{ maxRetries }})
        </p>
        <p v-else class="mt-3 text-muted">
          Loading PDF...
        </p>
      </div>
      <div v-if="!loading && url">
        <vue-pdf-app 
          theme="dark" 
          :config="config" 
          :pdf="url" 
          @open="openHandler"
          @error="onPDFError"
        > 
        </vue-pdf-app>
      </div>
    </div>
  </div>
</template>

<script>
  import VuePdfApp from "vue-pdf-app";
  import LoadingScreen from "@/components/_universal/global/loading-screen.vue";
  import "vue-pdf-app/dist/icons/main.css";
  import print from "print-js";
  import axios from "axios";

  const getSidebar = () => ({
    viewThumbnail: true,
    viewOutline: true,
    viewAttachments: true,
  });
  export default {
    name: "PreviewPDF",
    components: {
      VuePdfApp,
      LoadingScreen,
    },
    data() {
      return {
        loading: true,
        url: null,
        wordURL: null,
        documentName: null,
        retryCount: 0,
        maxRetries: 30,
        retryInterval: 2000, // 2 seconds
        originalUrl: null, // Store the original URL
        config: {
          toolbar: false,
          sidebar: getSidebar(),
        },
      };
    },
    created() {
      // console.log('PDF Preview Component Created');
      // console.log('Route Query:', this.$route && this.$route.query);
      
      if (this.$route && this.$route.query && this.$route.query.url) {
        this.url = this.$route.query.url;
        this.originalUrl = this.$route.query.url; // Store original URL
        this.wordURL = this.$route.query.wordURL;
        this.documentName = this.$route.query.name;
        
        // console.log('PDF URL:', this.url);
        // console.log('Word URL:', this.wordURL);
        // console.log('Document Name:', this.documentName);
        
        this.validatePDFUrl();
      } else {
        // console.error('No URL found in route query parameters');
        this.loading = false;
      }
    },
    beforeDestroy() {
      // Clean up blob URLs to prevent memory leaks
      if (this.url && this.url.startsWith('blob:')) {
        // console.log('Cleaning up blob URL:', this.url);
        URL.revokeObjectURL(this.url);
      }
    },
    methods: {
      async validatePDFUrl() {
        // console.log('Starting PDF validation for URL:', this.url);
        
        if (!this.url) {
          // console.error('No URL provided for validation');
          this.loading = false;
          return;
        }

        try {
          // console.log(`PDF validation attempt ${this.retryCount + 1}/${this.maxRetries}`);
          
          // Try to fetch the PDF with proper headers to handle CORS
          const response = await axios.get(this.url, {
            timeout: 10000, // 10 second timeout
            responseType: 'blob', // Get as blob to avoid CORS issues
            headers: {
              'Accept': 'application/pdf',
            }
          });
          
          // console.log('PDF fetch response:', {
          //   status: response.status,
          //   statusText: response.statusText,
          //   contentType: response.headers['content-type'],
          //   dataSize: response.data.size
          // });
          
          if (response.status === 200 && response.data.size > 0) {
            // Create a blob URL for the PDF to avoid CORS issues
            const blob = new Blob([response.data], { type: 'application/pdf' });
            this.url = URL.createObjectURL(blob);
            
            // console.log('PDF successfully loaded, created blob URL:', this.url);
            this.loading = false;
            this.retryCount = 0;
          } else {
            throw new Error(`PDF not ready: ${response.status}, size: ${response.data.size}`);
          }
        } catch (error) {
          // console.error(`PDF validation attempt ${this.retryCount + 1}/${this.maxRetries} failed:`, {
          //   message: error.message,
          //   status: error.response && error.response.status,
          //   statusText: error.response && error.response.statusText,
          //   url: this.url
          // });
          
          if (this.retryCount < this.maxRetries) {
            this.retryCount++;
            // console.log(`Retrying in ${this.retryInterval}ms...`);
            setTimeout(() => {
              this.validatePDFUrl();
            }, this.retryInterval);
          } else {
            // console.error("Max retries reached for PDF loading");
            this.loading = false;
            // Could show an error message to user here if needed
          }
        }
      },
      openHandler(pdf) {
        let outerContainerHtml = document.getElementById("outerContainer");
        outerContainerHtml.classList.add("sidebarOpen");
        if (pdf && !pdf.pdfSidebar.isOpen) {
          this.config.sidebar = getSidebar();
          pdf.pdfSidebar.isOpen = true;
        }
      },
      onPDFError(error) {
        // console.error("PDF loading error in vue-pdf-app:", error);
        // console.log('Current URL:', this.url);
        // console.log('Current retry count:', this.retryCount);
        
        // If PDF fails to load in the viewer, retry the validation
        if (this.retryCount < this.maxRetries) {
          // console.log('Retrying due to PDF viewer error...');
          this.loading = true;
          this.retryCount++;
          setTimeout(() => {
            this.validatePDFUrl();
          }, this.retryInterval);
        } else {
          // console.error('Max retries reached due to PDF viewer errors');
        }
      },
      async downloadPDF() {
        // console.log('Downloading PDF...');
        const downloadUrl = this.originalUrl || this.url;
        // console.log('Download URL:', downloadUrl);
        
        try {
          const response = await axios.get(downloadUrl, {
            responseType: "arraybuffer",
          });
          const blob = new Blob([response.data], {type: "application/pdf"});
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = this.documentName || 'document.pdf';
          link.click();
          // console.log('PDF download initiated');
        } catch (error) {
          // console.error('Error downloading PDF:', error);
        }
      },
      // downloadPDF() {
      //   // window.open(this.url, "_blank");
      //   let link = document.createElement("a");
      //   link.href = this.url;
      //   link.download = "file.pdf";
      //   document.body.appendChild(link);
      //   this.$nextTick(() => {
      //     link.click();
      //     document.body.removeChild(link);
      //   });
      // },
      onOpenInWord() {
        if (!this.wordURL) return;
        var lnk = "ms-word:ofe|u|" + this.wordURL + "|a|Web";
        window.location.href = lnk;
      },
      onPrint() {
        const printUrl = this.originalUrl || this.url;
        // console.log('Printing PDF from URL:', printUrl);
        if (!printUrl) return;
        printJS(printUrl);
      },
    },
  };
</script>
<style scoped lang="scss">
  .pdf-preview {
    height: 85vh;
    .pdf-container > div {
      height: 100%;
    }
  }
</style>
